module.exports = __webpack_public_path__ + "img/9.b70953e0.png";